import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import { Table, type Column } from "@freightsimple/ui-core/Table/Table";
import { TextCell } from "@freightsimple/ui-core/Cells/TextCell";
import { type PerformanceBreakdown } from "@freightsimple/generated-carriers-openapi-client/models/PerformanceBreakdown";
import { formatPercent } from "@/App/Views/carrierFormatting";

/**
 * A labelled slice of the carrier's freight with its share of the whole.
 *
 * Weight, density, linear feet, handling units, delivery geography and service
 * mix are all the same shape, so they all render through here. The title and the
 * column header carry which question is being answered.
 */
export function PerformanceBreakdownTable({
  title,
  description,
  header,
  rows,
}: {
  title: string;
  description: string;
  header: string;
  rows: PerformanceBreakdown[];
}) {
  const columns: Column<PerformanceBreakdown>[] = [
    {
      key: "label",
      header,
      render: (row) => <TextCell value={row.label} />,
    },
    {
      key: "count",
      header: "Shipments",
      align: "right",
      render: (row) => (
        <TextCell value={row.shipmentCount.toLocaleString("en-CA")} />
      ),
    },
    {
      key: "share",
      header: "Share",
      align: "right",
      render: (row) => (
        <TextCell value={formatPercent(row.sharePercentage)} color="muted" />
      ),
    },
  ];

  return (
    <Panel title={title} description={description} fullBleed>
      <Table
        columns={columns}
        data={rows}
        rowKey={(row) => row.label}
        emptyMessage="Nothing recorded for this period."
      />
    </Panel>
  );
}
